<template>
  <div class="vx-row">
    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base">
      <form @submit.prevent="onSubmit" enctype="multipart/form-data" id="account-manage-uc">
        <vx-card title="Edit Company">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Company Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input v-validate="'required'" name="Company Name" class="w-full" v-model="name" />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Company Name')"
              >{{ errors.first('Company Name') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Company Phone</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="Company Phone"
                class="w-full"
                v-model="phone"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Company Phone')"
              >{{ errors.first('Company Phone') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>
                Company Description
                <small>*Max. 1000 Character</small>
              </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <quill-editor
                v-model="description"
                v-validate="'required|max:1000'"
                name="Description"
                :options="editorDesc"
              >
                <div id="desc" slot="toolbar">
                  <quill-custom />
                </div>
              </quill-editor>
              <span
                class="text-danger text-sm"
                v-show="errors.has('Company Description')"
              >{{ errors.first('Company Description') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Domisili</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-model="domisili"
                  label="kota"
                  item-value="id"
                  :options="domisilis"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Address Detail</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="Address Detail"
                class="w-full"
                v-model="address_detail"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Address Detail')"
              >{{ errors.first('Address Detail') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Logo</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                type="file"
                id="filexx"
                name="Photo"
                accept="image/x-png, image/jpeg, image/jpg"
                @change="onCompanyFileSelected"
              />
              <br />
              <img :src="this.logo" class="rounded" width="200" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Activity</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                type="file"
                id="photo"
                name="Photos"
                accept="image/x-png, image/jpeg, image/jpg"
                @change="onCompanyMultipleFileSelected"
                multiple
              />
              <br />
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
                v-for="photo in this.activities"
                :key="photo"
              >
                <img :src="photo" class="rounded" width="100" />
              </vs-col>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" button="submit">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import QuillCustom from '../template/QuillCustom'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import axios from '../../../axios'
import router from '../../../router'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  data() {
    return {
      userAuth: JSON.parse(localStorage.getItem('user')),
      colorAlert: 'primary',
      titleAlert: 'Alert',
      activeAlert: false,
      valueInput: '',
      file: null,
      name: '',
      photo: '',
      error_photo: false,
      photos: [],
      error_photos: false,
      phone: '',
      description: '',
      domisili_id: '',
      address_detail: '',
      domisilis: [],
      domisili: {},
      logo: '',
      activities: [],
      company: '',
      editorDesc: {
        modules: {
          toolbar: '#desc'
        }
      },
    }
  },
  components: {
    quillEditor,
    'v-select': vSelect,
    Datepicker,
    QuillCustom
  },
  mounted() {
    //console.log('ini mounted')
    this.$vs.loading({
      background: this.backgroundLoading,
      color: this.colorLoading,
      container: "#account-manage-uc",
      scale: 0.45
    })

    axios.get('/lokasi?limit=10000', {})
      .then(res => {
        if (res.status != 200) {
          console.log(res.status)
        } else {
          console.log(res)
          this.domisilis = res.data.data
          // this.domisili = this.domisilis.find(x => x.id === this.company.domisili.id) // find the post index 
          // console(this.domisili)
          this.$vs.loading.close("#account-manage-uc > .con-vs-loading")
        }


      })
      .catch(error => {
        console.log(error.response)
        this.$vs.loading.close("#account-manage-uc > .con-vs-loading")
      })
    axios.get('job-portal/web/company/' + this.$route.params.companyId, {})
      .then(res => {
        if (res.status != 200) {
          console.log(res.status)

        } else {
          this.company = res.data
          this.domisili = res.data.domisili
          this.name = res.data.name
          this.phone = res.data.phone
          res.data.role == 0 ? this.role = { id: 0, name: 'Company' } : { id: 1, name: 'Admin' }
          this.address_detail = res.data.address_detail
          this.description = res.data.description
          this.logo = res.data.photo
          this.activities = res.data.photos
          console.log(res)
          //this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
        }


      })
      .catch(error => {
        console.log(error.response)
      })

  },

  methods: {

    onCompanyFileSelected(event) {
      this.photo = event.target.files[0]
    },
    onCompanyMultipleFileSelected(event) {
      for (var i = 0; i < event.target.files.length; i++) {
        this.photos[i] = event.target.files[i];

      }
    },
    onSubmit() {
      var formData = new FormData();
      if (this.photo) {
        formData.append('photo', this.photo, this.photo.name)
      }
      if (this.photos) {
        for (var i = 0; i < this.photos.length; i++) {
          formData.append('photos[' + i + ']', this.photos[i])

        }

      }
      console.log(this.$route.params.userId)
      formData.append('id', this.$route.params.companyId)
      formData.append('user_id', this.$route.params.userId)
      formData.append('name', this.name)
      formData.append('description', this.description)
      formData.append('domisili_id', this.domisili.id)
      formData.append('phone', this.phone)
      formData.append('address_detail', this.address_detail)
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: "#account-manage-uc",
            scale: 0.45
          })
          axios.post('job-portal/web/company/update', formData)
            .then(res => {
              if (res.status != 200) {
                this.$vs.loading.close("#account-manage-uc > .con-vs-loading")
                this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
              } else {
                console.log(res.data)
                this.$vs.loading.close("#account-manage-uc > .con-vs-loading")
                this.acceptAlert('success', 'Berhasil', 'Anda berhasil edit company')
                router.push('/job')
              }


            })
            .catch(error => {
              console.log(error.response)
              this.$vs.loading.close("#account-manage-uc > .con-vs-loading")
            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
          this.$vs.loading.close("#account-manage-uc > .con-vs-loading")
        }
      })
    },

    acceptAlert(color, title, message) {
      this.$vs.notify({
        color,
        title,
        text: message
      })
    },
  }
}
</script>
